<template>
  <div>
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Chi tiết Thiết bị</h1>
      <div class="btn-group float-right">
        <button
          class="btn btn-outline-secondary"
          @click="$router.push('/list-device')"
        >
          <i class="bx bx-arrow-back"></i> Quay lại
        </button>
      </div>
    </div>
    <div class="p-10 m-1 b-t-1-869fb229">
      <div class="card-body form-row">
        <div class="col-12">
          <div class="tab-content" id="myTabContent">
            <div class="tab-pane fade show active" id="ttc">
              <div class="form-row" style="width: 50%">
                <div class="form-detail">
                  <h1>1. Thông tin thiết bị</h1>

                  <div class="form-group form-row">
                    <label for="" class="col-sm-3 col-form-label"
                      >Tên thiết bị<span class="float-right">:</span></label
                    >
                    <div class="col-sm-9">
                      <p class="form-control-plaintext f12">
                        {{ detail?.categoryName }}
                      </p>
                    </div>
                  </div>

                  <div class="form-group form-row">
                    <label for="" class="col-sm-3 col-form-label"
                      >Mã Serial<span class="float-right">:</span></label
                    >
                    <div class="col-sm-9">
                      <p class="form-control-plaintext f12">
                        {{ detail?.serial }}
                      </p>
                    </div>
                  </div>

                  <div class="form-group form-row">
                    <label for="" class="col-sm-3 col-form-label"
                      >Kho<span class="float-right">:</span></label
                    >
                    <div class="col-sm-9">
                      <p class="form-control-plaintext f12">
                        {{ detail?.inventoryName }}
                      </p>
                    </div>
                  </div>

                  <div class="form-group form-row">
                    <label for="" class="col-sm-3 col-form-label"
                      >Mã giới thiệu<span class="float-right">:</span></label
                    >
                    <div class="col-sm-9">
                      <p class="form-control-plaintext f12">
                        {{ detail?.referralCode }}
                      </p>
                    </div>
                  </div>

                  <div class="form-group form-row">
                    <label for="" class="col-sm-3 col-form-label"
                      >Trạng thái<span class="float-right">:</span></label
                    >
                    <div class="col-sm-9">
                      <p class="form-control-plaintext f12">
                        <span
                          class="badge"
                          :class="
                            transformDataColor(detail?.status, optionStatus)
                          "
                        >
                          {{ detail.status | transformData(optionStatus) }}
                        </span>
                      </p>
                    </div>
                  </div>

                  <div class="form-group form-row">
                    <label for="" class="col-sm-3 col-form-label"
                      >Thời gian xuất bán<span class="float-right"
                        >:</span
                      ></label
                    >
                    <div class="col-sm-9">
                      <p class="form-control-plaintext f12">
                        {{ detail?.dateSale | formatDate("HH:mm, DD/MM/YYYY") }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-row mt-1">
                <div class="form-detail">
                  <div class="d-flex justify-content-between">
                    <h1>2. Lịch sử luân chuyển</h1>
                  </div>
                  <div class="table-responsive">
                    <table
                      class="table table-hover table-bordered"
                      style="max-height: 400px; overflow-y: auto"
                    >
                      <thead class="thead-light">
                        <tr>
                          <th scope="col" class="text-center">Thời gian</th>
                          <th scope="col" class="text-center">Loại</th>
                          <th scope="col" class="text-center">Kho chuyển đi</th>
                          <th scope="col" class="text-center">Kho nhận</th>
                          <th scope="col" class="text-center">Trạng thái</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          class="table-row"
                          v-for="(item, index) in detail?.infoDeviceHistories"
                          :key="index"
                        >
                          <td class="text-center">
                            {{
                              item.dateCreate | formatDate("HH:mm DD/MM/YYYY")
                            }}
                          </td>

                          <td class="text-center">
                            {{
                              item.type === "TRANSFER" &&
                              item.reason === "TRANSFER_AGENCY"
                                ? "Điều chuyển đại lý"
                                : item.type | transformData(optionTypeBill)
                            }}
                          </td>
                          <td class="text-center">
                            {{ item.inventoryNameExport }}
                          </td>
                          <td class="text-center">
                            {{ item.inventoryNameImport }}
                          </td>
                          <td class="text-center">
                            <span
                              class="badge"
                              :class="[item.status ? item.status : '']"
                            >
                              {{ item.status | transformData(optionStatusHis) }}
                            </span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true">
    </VueLoadingOverlay>
  </div>
</template>
<script>
// import Config from '../../../thirdParty/config'
import Config from '@/thirdParty/config'
import { DeviceService } from '@/services/device.service'
// import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      showLoading: false,
      dataUser: JSON.parse(localStorage.getItem('userData')) ?? {},
      id: this.$route.params.id,
      detail: {},
      optionStatus: Config.statusDevices,
      optionState: [],
      optionTypeBill: Config.typeBill,
      optionReason: [],
      optionStatusHis: Config.statusWarehouse,
      Config
    }
  },

  computed: {
    // ...mapGetters({
    //   dataPermission: 'role/dataPermission'
    // })
  },

  filters: {
    transformData (data, dataConfig) {
      const dataReturn = dataConfig?.filter((e) => e.id === data)
      if (dataReturn.length === 0) {
        return data
      }
      return dataReturn[0].text
    }
  },

  created () {
    this.fetchData()
  },

  methods: {
    transformDataColor (data, dataConfig) {
      const dataReturn = dataConfig.filter((e) => e.id === data)
      if (dataReturn.length === 0) {
        return ''
      }
      return dataReturn[0].bgColor
    },
    backToList () {
      this.$router.push('/list-device')
    },

    async fetchData () {
      console.log('this.id', this.$route.params.id)
      try {
        this.showLoading = true
        const data = await DeviceService.DetailDevice({
          id: this.$route.params.id
        })
        if (data.success || data.code === 1000) {
          this.detail = data.data
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.showLoading = false
      }
    },

    detailWarranty (id) {
      const routeData = this.$router.resolve({
        path: `/warranty/${id}`
      })
      window.open(routeData.href, '_blank')
    }
  }
}
</script>

<style scoped>
.pagination-bottom {
  display: flex;
  justify-content: flex-end;
  margin-right: 10px;
}
.breadcrumb-area {
  margin-bottom: 20px;
}
</style>
